const messages = {
    en: {
      contibution: "Contribution",
      editContibution: "Edit Contribution",
      myConrtibutionDetails: "Question details (question and answers aren't editable)",
      approved: "approved",
      declined: "declined",
      pending: "pending",
      status: "Status",
      creationDate: "Created at",
      subject: "Subject",
      userName: "User name"
    },
    ru: {
      contibution: "Bопросы, добавленные пользователями",
      editContibution: "Изменить добавленные вопросы",
      myConrtibutionDetails: "Подробности моего добавленного вопроса (не редактируется)",
      approved: "одобренный",
      declined: "отклоненный",
      pending: "в ожидании",
      status: "Cтатус",
      creationDate: "Создан",
      subject: "Предмет",
      userName: "Имя пользователя",
    }
  };

  export default messages;